import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

import { preloadGetProductCategoryHierarchy } from '@/api/react-query'

// `listQ` searches the category tree in the left column; `q` belongs to the detail route's product
// table in the right one. Two separate params because both panels are mounted at once, and a single
// `q` meant searching the tree also filtered (and emptied) the selected category's product list.
const CategorySearchSchema = z.object({
	listQ: z.string().optional()
})

export const Route = createFileRoute('/_authenticated/_general/product-categories')({
	validateSearch: CategorySearchSchema,
	loader: async ({ context }) => await preloadGetProductCategoryHierarchy(context, {}),
	staticData: {
		crumb: ({ context: { L } }) => L.ProductCategories.Title()
	}
})
